import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	paperStyles: {
		paddding: '2rem !important'
	},
	heading: {
		fontWeight: '600',
		color: theme.palette.primary.main,
		width: '70%',
		padding: '0',
		textAlign: 'left',
		margin: '0 auto !important'
	},
	floorAutomationContainer: {
		width: '92%',
		margin: '0 auto',
		padding: '2.4rem 3rem',
		border: '1px solid #9FE3C1',
		borderRadius: '16px',
		backgroundColor: '#F3FCF7'
	},
	floorAutomationContent: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: '1.6rem'
	},
	floorAutomationIcons: {
		display: 'flex',
		alignItems: 'center',
		gap: '0.8rem'
	},
	floorAutomationIcon: {
		fontSize: '2.4rem',
		color: '#0F9D58'
	},
	floorAutomationTitle: {
		fontSize: '2.4rem',
		fontWeight: 700,
		lineHeight: 1.2,
		color: '#087443',
		marginBottom: '1rem'
	},
	floorAutomationDescription: {
		fontSize: '1.6rem',
		lineHeight: 1.7,
		color: '#2E6B4E',
		maxWidth: '90rem'
	},
	floorAutomationButton: {
		'&&': {
			marginTop: '2rem',
			padding: '1rem 2rem',
			borderRadius: '10px',
			backgroundColor: '#00A86B',
			color: '#FFFFFF',
			fontSize: '1.5rem',
			fontWeight: 600,
			textTransform: 'none',
			boxShadow: 'none'
		},
		'&&:hover': {
			backgroundColor: '#009961',
			boxShadow: 'none'
		}
	}
}));
